import {creates, ElementSpec, hoistCmp, HoistProps} from '@xh/hoist/core';
import {VirtualGridModel} from './VirtualGridModel';
import {ColDef, GetContextMenuItemsParams, GetRowIdParams, MenuItemDef} from 'ag-grid-community';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {agGrid} from '@xh/hoist/cmp/ag-grid';
import {ReactElement} from 'react';

export interface VirtualGridProps<T> extends HoistProps<VirtualGridModel<T>> {
    onModelReady?: (model: VirtualGridModel<T>) => void;
    columnDefs: ColDef[];
    defaultColDef?: ColDef;
    queryUrl: string;
    showRowBorders?: boolean;
    showCellBorders?: boolean;
    showHover?: boolean;
    stripeRows?: boolean;
    getRowId: (GetRowIdParams: GetRowIdParams<T>) => string;
    ctxMenu?: (
        GetContextMenuItemsParams: GetContextMenuItemsParams<T>
    ) => (string | MenuItemDef<T>)[];
    onRowDoubleClicked?: (T) => void;
    persistKey?: string;
}

// @ts-ignore
export const virtualGrid = hoistCmp.factory({
    model: creates(VirtualGridModel),
    render({model, ...props}) {
        const {columnDefs, defaultColDef, getRowId, ctxMenu} = props;
        return panel({
            item: agGrid({
                model: model.gridModel,
                columnDefs,
                defaultColDef,
                dataTypeDefinitions: {enum: {extendsDataType: 'text', baseDataType: 'text'}},
                getRowId,
                getRowHeight: null,
                columnMenu: 'new',
                rowSelection: 'single',
                getContextMenuItems: ctxMenu,
                advancedFilterParent: null,
                animateRows: false,
                rowModelType: 'serverSide',
                serverSideDatasource: model.gridDataSource,
                loadingCellRenderer: () => null,
                cacheBlockSize: 50,
                maxBlocksInCache: 2,
                blockLoadDebounceMillis: 50,
                debug: false
            })
        });
    }
}) as <T>(arg: ElementSpec<VirtualGridProps<T>>) => ReactElement<VirtualGridProps<T>, any>;
